import {
  BusinessPlanOptions,
  FamilyPlanOptions,
  getLocationPlans,
  calculateFamilyPlanCost,
  calculateBusinessPlanCost,
  Location,
} from "@ecologi/shared";

export function selectPlanData(
  location: Location | null,
  selectedPlanId: string,
  selectedPlanAddons?: FamilyPlanOptions | BusinessPlanOptions
) {
  const {
    businessAddonsForLocation,
    businessPlanIdForLocation,
    currencySymbol,
    familyAddonsForLocation,
    familyPlanIdForLocation,
    plansForLocation,
  } = getLocationPlans(location);

  const isFamilyPlan = selectedPlanId === familyPlanIdForLocation;
  const isBusinessPlan = selectedPlanId === businessPlanIdForLocation;
  const selectedPlan = isFamilyPlan
    ? {
        price: parseFloat(
          calculateFamilyPlanCost(
            familyAddonsForLocation,
            selectedPlanAddons as FamilyPlanOptions
          )
        ),
        title: "Family",
      }
    : isBusinessPlan
    ? {
        price: parseFloat(
          calculateBusinessPlanCost(
            businessAddonsForLocation,
            selectedPlanAddons as BusinessPlanOptions
          )
        ),
        title: "Business",
      }
    : plansForLocation[selectedPlanId];

  return {
    selectedPlan,
    currencySymbol,
    isFamilyPlan,
    isBusinessPlan,
  };
}
